import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KPI } from "@/components/Primitives";
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis, Tooltip, PieChart, Pie, Cell } from "recharts";

export default function RMM() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/rmm").then(r => setD(r.data)); }, []);
  if (!d) return <div className="text-zinc-500 text-sm">Loading…</div>;

  const statusData = Object.entries(d.status_distribution || {}).map(([k, v]) => ({ name: k, value: v }));
  const osData = Object.entries(d.os_distribution || {}).map(([k, v]) => ({ name: k, value: v }));
  const hb = d.health_buckets || {};
  const colors = ["#2563EB", "#10B981", "#F59E0B", "#EF4444", "#0EA5E9", "#8B5CF6"];

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">RMM Operations Center</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Endpoint Monitoring</h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        <KPI testid="kpi-healthy" label="Healthy Endpoints" value={hb.healthy ?? 0} tone="good" />
        <KPI testid="kpi-warning" label="Warning" value={hb.warning ?? 0} tone="warn" />
        <KPI testid="kpi-critical" label="Critical" value={hb.critical ?? 0} tone="bad" />
        <KPI testid="kpi-patch" label="Patch Compliance" value={d.patch_compliance_pct == null ? "—" : `${d.patch_compliance_pct}%`} tone="good" />
        <KPI testid="kpi-av" label="AV Coverage" value={d.antivirus_coverage_pct == null ? "—" : `${d.antivirus_coverage_pct}%`} tone="good" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-zinc-950 border border-zinc-900 rounded-md p-5">
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mb-3">Status Distribution</div>
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie data={statusData} dataKey="value" nameKey="name" innerRadius={50} outerRadius={90} paddingAngle={2}>
                {statusData.map((_, i) => <Cell key={i} fill={colors[i % colors.length]} />)}
              </Pie>
              <Tooltip contentStyle={{ background: "#0a0a0c", border: "1px solid #27272a", borderRadius: 6 }} />
            </PieChart>
          </ResponsiveContainer>
          <div className="grid grid-cols-2 gap-2 mt-2">
            {statusData.map((s, i) => <div key={s.name} className="flex items-center gap-2 text-xs"><span className="w-2 h-2 rounded-sm" style={{ background: colors[i%colors.length] }} />{s.name} <span className="ml-auto text-zinc-500 font-mono">{s.value}</span></div>)}
          </div>
        </div>
        <div className="bg-zinc-950 border border-zinc-900 rounded-md p-5">
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mb-3">Operating System Spread</div>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={osData}>
              <XAxis dataKey="name" stroke="#52525b" fontSize={10} />
              <YAxis stroke="#52525b" fontSize={10} />
              <Tooltip contentStyle={{ background: "#0a0a0c", border: "1px solid #27272a", borderRadius: 6 }} cursor={{ fill: "#18181b" }} />
              <Bar dataKey="value" fill="#2563EB" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
